import React, {FunctionComponent, useContext, useMemo, useState} from "react";
import {Currency, PaymentInfo, RegistrationStatus} from "/src/domain/challenges/ChallengeRegistrationData";
import {useTranslation} from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import {ToggleButton, ToggleButtonGroup} from "@mui/material";
import {CurrencyRuble, Euro} from "@mui/icons-material";
import cs from "classnames";
import {
    ChallengeRegistrationContext,
    ChallengeRegistrationContextProps
} from "/src/contexts/ChallengeRegistrationContext";

export type PaymentOptionsViewProps = {
    className?: string;
    paymentInfo?: PaymentInfo;
}

export const PaymentOptionsView: FunctionComponent<PaymentOptionsViewProps> = ({
                                                                                   paymentInfo,
                                                                                   className
                                                                               }) => {
    const classes = useStyles();
    const {t} = useTranslation();

    const {currency, setCurrency} = useContext(ChallengeRegistrationContext) as ChallengeRegistrationContextProps;
    const [provider, options] = useMemo(() => {
        const _options = paymentInfo?.options?.[currency] || [];
        if (currency == Currency.RUB)
            return ['tinkoff', _options];
        if (currency == Currency.EUR)
            return ['stripe', _options];
        return ['stripe', _options];
    }, [currency]);

    if (!paymentInfo || paymentInfo?.status == RegistrationStatus.PAID) return null;

    const handleChangeCurrency = (event: React.MouseEvent<HTMLElement>, newCurrency: string | null) => {
        if (!newCurrency) return;
        setCurrency(newCurrency as Currency);
    }


    return (
        <div className={cs(classes.container, className)}>
            <input hidden name={"provider"} value={provider}/>
            <ToggleButtonGroup
                value={currency}
                exclusive
                onChange={handleChangeCurrency}
                color={"primary"}
            >
                <ToggleButton value={Currency.RUB}>
                    {t('payIn')} <CurrencyRuble/>
                </ToggleButton>
                <ToggleButton value={Currency.EUR}>
                    {t('payIn')} <Euro/>
                </ToggleButton>
            </ToggleButtonGroup>
            <div className={classes.paymentOptionsContainer}>
                {options.map(o => (
                    <div className={classes.paymentOptionContainer}>
                        <div className={classes.paymentOptionLabel}>{t(o.label)}</div>
                        <div>{o.price} {currency.toString().toUpperCase()}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}

const useStyles = makeStyles({
    container: {
        margin: "1rem 0"
    },
    paymentOptionsContainer: {
        margin: "1rem 0"
    },
    paymentOptionContainer: {
        display: "flex"
    },
    paymentOptionLabel: {
        marginRight: "1rem",
        fontWeight: 600
    }
});